<template>
    <section class="section section-lg text-center bg-white">
        <div class="container container-wide">
            <div>
                <span class="header-text">ご利用停止のアンケートにご協力ください</span>
            </div>
            <div v-if="pageLoadingIndicator" class="page-loading-indicator">
                <img src="/images/eowp/animation/loading-spinner.jpg" />
            </div>
            <div v-else>  
                <div class="subheader-text">
                    「英辞郎 on the WEB Pro」をご利用いただき、誠にありがとうございました。 
                    今後のサービス向上のため、ご利用を停止された理由について、簡単なアンケートにご協力いただけますと幸いです。
                    お客様の声をもとに、より良いサービスの提供を目指してまいります。
                    ご協力のほど、よろしくお願い申し上げます。
                </div>
            </div>
            <div id="surveyFrame">
                <!-- The survey is loaded here, from JS-->
            </div>
            <div class="button escape-button" id="escape-button" v-on:click="navigateToNext()">
                アカウントページに進む
            </div>
        </div>
    </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
    width: auto;
    margin: 0px 24% 0px 24%;
}
.header-text{
    position: relative;
    display: inline-flex;
    font-size: 28px;
    line-height: 28px;
    color: #000000;
    padding: 0px 0px 60px 0px;
}
.page-loading-indicator {
    text-align: center;
    position: relative;
    display: inline-flex;
    padding-top: 20px!important;
}
.page-loading-indicator > img {
    height: 282px;
    aspect-ratio: 1/1;
}
.subheader-text{
    font-size: 18px;
    max-width: 660px;
    margin: auto;
    padding: 0px 0px 60px 0px;
}
#surveyFrame{
    margin: 0px auto 60px auto;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    border: none; 
}
ul{
    padding: 10px 0px;
}
li{
    padding: 5px 0px;
    font-size: 16px;
}
.button-disabled{
    background-color: #dddddd!important;
    color: #bbbbbb!important;
    border-color: #dddddd!important;
    pointer-events: none;
    cursor: default;
}
.sub-button-container {
    text-align: center;
    padding-top: 15px!important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 660px;
    margin: auto;
}
.escape-button{
    display: grid;
    justify-self: center;
    place-items: center;
    margin: 10px;
    width: 100%;
    max-width: 330px;
    height: 56px;
    font-size: 18px;
    line-height: 20px;
    background: #971E22;
    font-weight: bold;
    color: #FAFAFA;
    border: none;
}
@media screen and (max-width: 660px){
body{
    font-size: 14px;
}
.container{
    margin: 0px;
    width: 100%;
}
.header-text{
    font-size: 24px;
    line-height: 24px;
    padding: 0px 0px 30px 0px;
}
.subheader-text{
    font-size: 12px;
}
#surveyFrame{
    max-width: 100%;
}
ul{
    font-size: 14px;
}
li{
    font-size: 14px;
}
.sub-button-container{
    flex-direction: column;
    max-width: 75%;
}
}
@media screen and (max-width: 360px){
ul{
    font-size: 13px;
}
li{
    font-size: 13px;
}
.button{
    padding: 10px 10px;
    min-width: 0px;
}
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import DialogMixin from '../../js/helpers/mixins/DialogMixin';
import ShopConstants from '../../js/helpers/ShopConstants';

const CANCELLATION_SURVEY_LINK = ShopConstants.CANCELLATION_SURVEY_LINK;

export default {
    data() {
        return {
            pageLoadingIndicator: true,
            buttonDisabledForProcessing: false,
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            sessionDetails: 'user/session_details',
            pathIntention: 'user/path_intention',
            userSessionId: 'user/session',
        }),
    },
    methods: {
        ...mapActions({
            setPathIntention: 'user/setPathIntention',
            fetchSessionDetails: 'user/fetchSessionDetails',
            logActivity: 'log/logActivity',
            getSubscriptionInfo: 'ssr/getSubscriptionInfo',
            subscriberType: 'transition/subscriberType',
            getInfo: 'info/getInfo',
            saveCouponId: 'coupon/saveCouponId',
            getCouponId: 'coupon/getCouponId',
            setChosenItem: 'ncs/setChosenItem',
            trackClickEvent: 'ga/trackClickEvent',
        }),
        navigateToNext(){
            this.setPathIntention('');
            this.$router.push("/account");
        },
    },
    mounted() {
        const iframe = document.createElement('iframe');
        iframe.src = CANCELLATION_SURVEY_LINK;
        iframe.width = '100%';
        iframe.height = '1900';
        iframe.style.border = 'none';
        const container = document.getElementById("surveyFrame");
        if (container)
            container.appendChild(iframe);

        iframe.onload = () => {
            this.pageLoadingIndicator = false;
        };
    },
    async created(){
        this.pageLoadingIndicator = true;
        if(this.userSessionId && !this.sessionDetails){
            await this.fetchSessionDetails(this.userSessionId);
            if(!this.sessionDetails){
                this.$router.push("/signin");
            }
        }
        this.pageLoadingIndicator = false;
    },
    mixins: [
        DialogMixin
    ]
};
</script>
